import Vue from 'vue'
import Router from 'vue-router'
import basic from '@/router/modules/basic'
import home from '@/router/modules/home'
import logistics from '@/router/modules/logistics'
import Process from '@/router/modules/process'
import packing from '@/router/modules/packing'
import stockStore from '@/router/modules/stockStore'
import agrStock from '@/router/modules/agrStock'
import more from '@/router/modules/more'
import { TOKEN_NAME } from '@/constant/config'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: { name: 'Login' }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login')
    },
    {
      // 包装溯源
      path: '/tp',
      name: 'Tp',
      props: route => ({
        traceCode: route.query.c
      }),
      component: () => import('@/views/packing/TracePacking')
    },
    {
      // 种植溯源
      path: '/tc',
      name: 'Tc',
      props: route => ({
        traceCode: route.query.c
      }),
      component: () => import('@/views/productManage/TraceSource')
    },
    home,
    ...basic,
    ...stockStore,
    packing,
    logistics,
    Process,
    agrStock,
    more
  ]
})

const devRoutes = [
  {
    path: '/svg',
    component: () => import('@/icons/SvgExample')
  }
]

if (process.env.NODE_ENV === 'development') {
  devRoutes.forEach(i => {
    router.addRoute(i)
  })
}

const whiteList = [
  'Login', 'Tp', 'Tc'
]
router.beforeEach((to, from, next) => {
  const token = JSON.parse(localStorage.getItem(TOKEN_NAME))
  // 未登录 无Token信息
  if (!token) {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      next({ name: 'Login' })
    }
    return
  }
  // 登录状态
  next()
})

export default router
